export function ContactPage() {
  return (
    <div>
      <section className="relative text-gray-700 body-font">
        <div className="container px-5 py-24 mx-auto">
          <div className="flex flex-col w-full mb-12 text-center">
            <h1 className="mb-4 text-2xl font-medium text-gray-900 sm:text-3xl title-font">Contact Us</h1>
            <p className="mx-auto text-base leading-relaxed lg:w-2/3">
              Please fill out the form below and we will get back to you as soon as possible.
            </p>
          </div>
          <div className="mx-auto lg:w-1/2 md:w-2/3">
            <div className="flex flex-wrap -m-2">
              <div className="w-1/2 p-2">
                <div className="relative">
                  <label className="text-sm leading-7 text-gray-600">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="w-full px-3 py-1 text-base leading-8 text-gray-700 transition-colors duration-200 ease-in-out bg-gray-100 border border-gray-300 rounded outline-none focus:border-blue-500"
                  />
                </div>
              </div>
              <div className="w-1/2 p-2">
                <div className="relative">
                  <label className="text-sm leading-7 text-gray-600">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="w-full px-3 py-1 text-base leading-8 text-gray-700 transition-colors duration-200 ease-in-out bg-gray-100 border border-gray-300 rounded outline-none focus:border-blue-500"
                  />
                </div>
              </div>
              <div className="w-full p-2">
                <div className="relative">
                  <label className="text-sm leading-7 text-gray-600">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    className="w-full h-32 px-3 py-1 text-base leading-6 text-gray-700 transition-colors duration-200 ease-in-out bg-gray-100 border border-gray-300 rounded outline-none resize-none focus:border-blue-500"
                  ></textarea>
                </div>
              </div>
              <div className="w-full p-2">
                <button
                  className="flex px-8 py-2 mx-auto text-lg text-white bg-blue-500 border-0 rounded focus:outline-none hover:bg-blue-600"
                  // onClick={() => {
                  //   window.open(`mailto:support@atcreate.ca?subject=AtCreate Support&body=${body}`)
                  // }}
                >
                  SUBMIT
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
